import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import { customStyle, inputAmountStyle, labelSyle, numberDecimalLimitRegex, 
    // validatePaymentMode 
} from '../../components/constant';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import moment from 'moment';
import { getAESLslipReferenceDropdown } from '../../dropdowns';
import Error from '../../errorHandlimg/Error';
import { adbLoanValidation } from '../../validations/paymentModeValidation';
import { getConditionalCOllectSaveButton } from '../../components/common';

const ADBView = ({dialogCloseHandler, isEditForm,isReceiptEdit=false, isView=false,contextValue,rowId,handleClose}) => {
    const [errorMgs, setErrorMgs] = useState();
    const [startDate, setStartDate] = useState()

    const {
        setModifyPaymentModeData,
        paymentModeFormHandler,
        studentBasicDetails, 
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceAmount,
        setBalanceMode,
        setloader,
        setCollectPayment,
        collectPayment,
        balanceAmount,
        setPaymentModeForm,
        validatePaymentMode
    } = contextValue;
    const validatePayment=async()=>{
        const error=await adbLoanValidation(paymentModeForm,collectPayment,balanceAmount)
        setErrorMgs(error)
        if(!error)
            {
               const isOk= await validatePaymentMode(studentBasicDetails,currentPaymentMode,paymentModeForm,selectedChargesAmount,bankMasterId,'',setBalanceAmount,setBalanceMode,setloader,setCollectPayment,balanceAmount,collectPayment)
               if(isOk){
                isReceiptEdit===true&&setModifyPaymentModeData((prev) => ({ ...prev, [rowId]: paymentModeForm }))
                isReceiptEdit&& handleClose(true)
               }
    
            }  
}
    const [referenceNumberDropdown, setReferenceNumberDropdown] = useState([{}])
    useEffect(() => {
        const getDropdown = async () => {
            setloader(true);
            const dropdown = await getAESLslipReferenceDropdown(studentBasicDetails);
            setReferenceNumberDropdown(dropdown);
            setloader(false)
        }
        // const getDepositSlipCreationDate= async()=>{
        //     setloader(true)
        //     const data =await getDepositSlipInfoByApplication(studentBasicDetails?.applicationId)
        //     const date = (data?.depositSlipInfoChargeStatusAndQuotationIdDTOS.find(item=>item?.quotationId==studentBasicDetails?.applicationQuotationId))?.depositSlipCreationDate
        //     setStartDate(date)
        //     setloader(false)
        // }
       !isView && getDropdown();
       //!isView && getDepositSlipCreationDate()
    }, [])

    const disabled=!(paymentModeForm?.paidAmount && paymentModeForm?.referenceNumber && paymentModeForm?.paymentModeDate)

    return (
        <>
            {!isView&&!isReceiptEdit&&<div className=" d-flex justify-content-between align-items-center mt-2">
                <span className="large-bold color-dark">Amount deposited in bank (ADB)</span>
            </div>
            }
            <Row>
                <Col md="4">
                    <div>
                        <AAutoComplete
                            label="AESL Slip Reference No.*"
                            labelStyle={labelSyle}
                            placeHolder="Select"
                            currentValue={paymentModeForm?.referenceNumber}
                            handleChange={(value) => {
                                setPaymentModeForm({ ...paymentModeForm, referenceNumber: value, paidAmount: value?.balanceAmount })
                            }}
                            items={referenceNumberDropdown}
                            isMulti={false}
                            isShowCount={false}
                            style={{ control: { height: "47px", width: '265px', borderRadius: "5px" } }}
                            isDisabled={isView}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <div>
                        <AInput
                            label="Balance Amount*"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.paidAmount}
                            customIcon={
                                <div className='large-semi-bold'>&#8377;</div>
                              }
                              customIconStyle={customStyle}
                            handler={(value) => {
                                if (
                                    !value || parseFloat(value) > 0
                                ) {
                                    paymentModeFormHandler('paidAmount', value)
                                }
        
                            }}
                            placeholder="Enter"
                            style={inputAmountStyle}
                            disabled={true}
                            regex={numberDecimalLimitRegex(10, 2)}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <div style={{ width: '265px' }}>
                        <CustomDatePickerV2
                            label="Bank Disbursement Date*"
                            labelStyle={labelSyle}
                            style={{ input: { minHeight: "47px" } }}
                            placeHolder="Select date"
                            value={paymentModeForm?.paymentModeDate}
                            handler={(index, date) => { paymentModeFormHandler("paymentModeDate", date) }}
                            isStartDate={true}
                            minDate={paymentModeForm?.referenceNumber?.depositSlipCreationDate}
                            maxDate={new moment(new Date())}
                            disabled={isView||!paymentModeForm?.referenceNumber}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <div>
                        <AInput
                            label="Bank Deposition ID"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.paymentModeDescription}
                            handler={(value) => { paymentModeFormHandler("paymentModeDescription", value) }}
                            placeholder="Enter"
                            style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                            disabled={isView}
                        />
                    </div>
                </Col>
            </Row>
            {getConditionalCOllectSaveButton(disabled,
                paymentModeForm,
                validatePayment,
                isReceiptEdit,
                isEditForm,
                isView,
                setModifyPaymentModeData,
                rowId,
                handleClose)}
            <Error errorMgs={errorMgs}/>
        </>
    )
}
export default ADBView;